import type { DevicePlatform } from '../../core/devices/deviceIdentity';
import { isNativeCapacitorSync } from '../../config/gapiProbes';

/**
 * Detects native platform using Capacitor.
 * Returns null if not running on a native platform.
 */
export async function detectNativePlatform(): Promise<DevicePlatform | null> {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (!Capacitor.isNativePlatform()) return null;
    const platform = Capacitor.getPlatform();
    if (platform === 'ios') return 'ios';
    if (platform === 'android') return 'android';
    return 'web';
  } catch {
    return null;
  }
}

/**
 * Resolves the device platform, falling back to 'web' if not native.
 */
export async function resolveDevicePlatform(): Promise<DevicePlatform> {
  const native = await detectNativePlatform();
  return native ?? 'web';
}

/** Sync read of the Capacitor bridge so native UI can skip YouTube iframes on first paint. */
export function isNativeShellSync(): boolean {
  return isNativeCapacitorSync();
}
